<template>
  <div class="ata-card">
    <div class="ata-card-header">
      <div class="ata-card-title">
        <slot name="title"></slot>
      </div>
    </div>
    <div class="ata-card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.ata-card {
  .ata-card-header {
    display: flex;
    align-items: center;
    padding: 6px 0;
  }

  .ata-card-body {
    padding: 6px 0;
  }

  .ata-card-title {
    flex: 1;
    color: var(--color-text-1);
    font-size: var(--el-font-size-large);
    line-height:  24px;
    font-weight: 500;
  }
}

</style>
